import portaro from '../portaro';

portaro.controller('TenderListCtrl', ['$scope', '$timeout', 'CONTEXT_PATH', 'currentAuth', 'tenderService',
    function($scope, $timeout, CONTEXT_PATH, currentAuth, tenderService) {

        $scope.CONTEXT_PATH = CONTEXT_PATH;
        $scope.currentAuth = currentAuth;

        $scope.init = function() {
            tenderService.query({active: true})
                .then(function(tenders) {
                    $scope.tenders = tenders;
                });
        };

    }
]);